import { FileText } from 'lucide-react'
import { Textarea } from '@/components/ui/textarea'

interface NarrativeCardProps {
  narrative: string
  onChange: (value: string) => void
}

export function NarrativeCard({ narrative, onChange }: NarrativeCardProps) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <h2 className="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">
        <FileText className="h-5 w-5 text-slate-400" />
        Sachverhalt
      </h2>
      <Textarea
        value={narrative}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Beschreibung des Mandanten, was passiert ist..."
        className="min-h-[100px]"
      />
    </div>
  )
}
